// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3NomU","container":"styles_container__r1IY_","title":"styles_title__21NJT","wrapper":"styles_wrapper__3E6hc","answer":"styles_answer__1tKfr"};